export interface GeneralState {
  allBanks: any[];
}

export enum GeneralActions {
  UPDATE_ALL_BANKS = "UPDATE_ALL_BANKS",
}
